import { Card, alpha, useTheme } from "@mui/material";
import FlexBox from "components/FlexBox";
import { H1, Paragraph } from "components/Typography";
import { FC, ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const AuthCard: FC<Props> = ({ title, subtitle, children }) => {
  const theme = useTheme();

  return (
    <FlexBox
      sx={{
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "100dvh",
        padding: 2,
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${alpha(theme.palette.primary.dark, 0.14)} 100%)`,
      }}
    >
      <Card
        sx={{
          padding: { xs: 3, sm: 4 },
          maxWidth: 520,
          width: "100%",
          boxShadow: theme.shadows[3],
          borderRadius: 3,
        }}
      >
        <FlexBox alignItems="center" flexDirection="column" justifyContent="center" mb={3}>
          <img
            src="/static/logo/logo.svg"
            style={{ width: 160, marginBottom: 16 }}
            alt="Agenda7"
          />
          <H1
            fontSize={22}
            fontWeight={700}
            sx={{
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textAlign: "center",
            }}
          >
            {title}
          </H1>
          {subtitle && (
            <Paragraph color="text.secondary" mt={0.5} textAlign="center" fontSize={14}>
              {subtitle}
            </Paragraph>
          )}
        </FlexBox>
        {children}
      </Card>
    </FlexBox>
  );
};

export default AuthCard;
